<!-- src/components/index.vue -->
  
<template>
  <section id="subTitleFont">
    <div class="container mx-auto" data-aos="fade-right">
      <div class="row row-col-sm-2 justify-content-center">
        <div id="firstobject" class="col p-4 align-items-center animate__animated d-flex justify-content-end" @mouseenter="addTada" @mouseleave="removeTada">
          <img :src="user?.ProfilePicture" class="columnimageleft rounded-circle">
        </div>
        <div class="col p-4 align-self-center text-left aboutthis">
          <h1 class="flex-grow-1 MainTitleFont textmain">{{ user?.name || 'Anon' }}</h1>
          <p class="pre-wrapper textsecondary">{{ user?.bio || 'lmao' }}</p>
        <!-- For each Link, we have an icon -->
        </div>
      </div>
    <div class="section-divider"></div>
    </div>
    <ProfilePagePart2ContentList :userId="user?.id" :userSettings="userSettings" data-aos="fade-right"/>
    
  </section>
</template>
<style>

</style>
<script>

import 'bootstrap/dist/css/bootstrap.min.css';
import ProfilePagePart2ContentList from '@/ProfilePagePart2ContentList.vue';
import axios from 'axios';
import AOS from 'aos'; // Import AOS for animations
import 'aos/dist/aos.css'; // Import AOS styles
import 'animate.css';
export default {
  name: 'ProfilePage',
  props: ['id'], // Expecting user ID as a prop
  components: {
    ProfilePagePart2ContentList,
  },
  data() {
    return { 
      user: null,  // Will store the user data
      userSettings: null,  // Will store the user settings
    };
  },
  watch: {
    // Watch for changes in the id prop
    id: {
      immediate: true,
      handler(newId) {
        if (newId) {
          this.fetchUserData(newId);
        }
      }
    }
  },
  mounted() {
    // Initialize AOS for animations (if needed)
    AOS.init();
    // Set initial document title
    this.updateDocumentTitle();
  },
  methods: {
    updateDocumentTitle() {
      document.title = `${this.user?.name || 'Anon'}'s Profile`;
    },
    // Fetch user data from API
    fetchUserData(userId) {
      // Same server in production, the local API during npm run serve
      const base = process.env.NODE_ENV === 'production'
        ? ''
        : 'http://localhost:3002';
      
    // Use the new username/profileurlName endpoint
    axios.get(`${base}/api/user/${userId}`)
      .then(response => {
        console.log('API Response:', response.data);
        this.user = response.data;
        this.updateDocumentTitle();
        
        // Now fetch user settings using the numeric ID from the user data
        return axios.get(`${base}/api/userSettings/${this.user.id}`);
      })
      .then(response => {
        console.log('User Settings Response:', response.data);
        this.userSettings = response.data; // Store user settings
      })
      .catch(error => {
        console.error('Error fetching user data:', error);
        this.user = null; // Reset user data on error
      });
    },
    // Toggle method for any property if you want to toggle something
    toggle(property) {
      this[property] = !this[property];
    },
    addTada() {
      const element = document.getElementById('firstobject');
      if (element) element.classList.add('animate__tada');
    },
    removeTada() {
      const element = document.getElementById('firstobject');
      if (element) element.classList.remove('animate__tada');
    },
  },
};

</script>
